import React, {useState} from 'react';
import {Button, Col, Form, Row} from "react-bootstrap";
import PropTypes from "prop-types";
import FormGroup from "../components/formGroup";
import {isObject} from "lodash";
import MySelect from "../components/form/mySelect";

function Adresse(props) {

    const [validated, doValidate] = useState(false);

    const [typeAdresse, updateTypeAdresse] = useState(
        isObject(props.item.TypeAdresseID)
            ? props.item.TypeAdresseID
            : props.parameters.TypeAdresseID.find(f => f.value === props.item.TypeAdresseID)
    );

    const [pays, updatePays] = useState(
        isObject(props.item.PaysID)
            ? props.item.PaysID
            : props.parameters.PaysID.find(f => f.value === props.item.PaysID)
    );

    const save = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (event.currentTarget.checkValidity() === false) {
            doValidate(!event.currentTarget.checkValidity())
        } else {
            const data = new FormData(event.currentTarget);
            props.save(Object.fromEntries(data));
        }
    };

    return (
        <Form key={props.item.AdresseID} noValidate
              validated={validated}
              onSubmit={save.bind(this)}>
            <Row>
                <Col xs={12} sm={6}>
                    <FormGroup label={"Ligne 1"}
                               name={"AdresseLigne1"}
                               defaultValue={props.item.AdresseLigne1}
                               required={true}/>

                    <FormGroup label={"Ligne 2"}
                               name={"AdresseLigne2"}
                               defaultValue={props.item.AdresseLigne2}
                               required={false}/>

                    <FormGroup label={"Code postal"}
                               name={"AdresseCodePostal"}
                               defaultValue={props.item.AdresseCodePostal}
                               required={true}/>

                    <FormGroup label={"Localité"}
                               name={"AdresseLocalite"}
                               defaultValue={props.item.AdresseLocalite}
                               required={true}/>
                </Col>
                <Col xs={12} sm={6}>

                    <FormGroup label={"Pays"}
                               name={"PaysID"}
                               type={MySelect}
                               value={pays}
                               options={props.parameters.PaysID}
                               onChange={updatePays}
                               required={true}/>

                    <FormGroup label={"État"}
                               name={"AdresseEtat"}
                               defaultValue={props.item.AdresseEtat}
                               required={false}/>

                    <FormGroup label={"Type d'adresse"}
                               name={"TypeAdresseID"}
                               type={MySelect}
                               value={typeAdresse}
                               options={props.parameters.TypeAdresseID}
                               onChange={updateTypeAdresse}
                               required={true}/>
                </Col>
            </Row>
            <Button type="submit"
                    variant="success"
                    size={"lg"}
                    className={"mr-3"}
                    block>
                Sauvegarder
            </Button>
        </Form>
    )
}

Adresse.propTypes = {
    save: PropTypes.func.isRequired,
};

export default Adresse;